import { styled } from '@mui/material/styles';
import { ListClasses } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { List } from 'shared/react-admin/List/List';

export const StyledList = styled(List)({
  marginTop: '24px',
  marginBottom: 0,
  backgroundColor: '#FAFAFA',
  [`& .${ListClasses.noActions}`]: {
    marginTop: 0,
  },
});

export const StyledListBox = styled(Box)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
});
